/**
 * Resuelve la URL de tienda según el user-agent (frente #2 / captación-app).
 * iOS → App Store; Android → Play Store; cualquier otro (desktop incluido) →
 * Play Store, que es un destino real y funcional (fallback de §5 de la spec).
 */
export function isIosDevice(
  userAgent: string,
  maxTouchPoints = navigator.maxTouchPoints,
): boolean {
  const ua = (userAgent ?? '').toLowerCase();
  return (
    /iphone|ipad|ipod/.test(ua) ||
    (/macintosh/.test(ua) && maxTouchPoints > 1)
  );
}

export function resolveStoreUrl(
  userAgent: string,
  stores: { appStoreUrl: string; playStoreUrl: string },
): string {
  return isIosDevice(userAgent) ? stores.appStoreUrl : stores.playStoreUrl;
}

/** Dónde está parada la persona. `desktop` es todo lo que no es un teléfono. */
export type DevicePlatform = 'ios' | 'android' | 'desktop';

/**
 * Distingue las TRES situaciones, a diferencia de `resolveStoreUrl`, que manda
 * el escritorio al Play Store como destino de respaldo.
 *
 * La página de descarga (`/app`, el destino del QR) necesita la diferencia: en
 * un computador no se puede instalar la app, así que ahí corresponde ofrecer
 * las dos tiendas en vez de empujar a una (ABC-399).
 */
export function resolvePlatform(
  userAgent: string,
  maxTouchPoints?: number,
): DevicePlatform {
  if (isIosDevice(userAgent, maxTouchPoints)) {
    return 'ios';
  }
  return /android/i.test(userAgent ?? '') ? 'android' : 'desktop';
}
